import { marker } from '@jsverse/transloco-keys-manager/marker';

marker('DATE');
marker('YEAR');

export enum FaDefaultFormat {
  DATE = 'DATE',
  YEAR = 'YEAR',
}
